import { ReactNode } from "react";
import { useSectionTracking } from "@/hooks/useSectionTracking";

interface SectionTrackerProps {
  name: string;
  children: ReactNode;
}

/**
 * Wrapper component that tracks when a landing page section becomes visible.
 * Uses IntersectionObserver to detect visibility and fires analytics events.
 */
export const SectionTracker = ({ name, children }: SectionTrackerProps) => {
  const sectionRef = useSectionTracking(name);

  return (
    <section ref={sectionRef as React.RefObject<HTMLElement>}>
      {children}
    </section>
  );
};
